var map = {
	"./activity.png": "1842",
	"./blank.png": "f8f1",
	"./resource.png": "79fa",
	"./resource_side_by_side.png": "6226",
	"./resource_with_text.png": "9f89",
	"./text_only.png": "26ed",
	"./title_only.png": "7fd8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c6fb";